import {
  type QConfigRandomConfig,
  QConfigRandomConfigType,
  QConfigRandomGroupBy,
} from '@exam-management/graphql';

export function getRandomConfigType(config?: QConfigRandomConfig | null) {
  if (!config) {
    return '-';
  }

  if (config.type === QConfigRandomConfigType.Fixed) {
    return 'เรียงตามลำดับ';
  }

  switch (config?.groupBy) {
    case QConfigRandomGroupBy.Part:
      return 'สุ่มแยกตามหมวด';
    case QConfigRandomGroupBy.Hierarchy:
      return 'สุ่มตามลำดับชั้น';
    default:
      return 'สุ่มทั้งชุด';
  }
}
